function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//

import G6 from '@antv/g6';
import { tooltip } from './components/g6_tooltip.mjs';
import { tooltipCss } from './components/g6_css.mjs';
import LineageService from '@/apps/data-platform/services/monitoring/lineage_service.js';
tooltipCss();
export default {
  props: {
    table: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      has_lineage: true,
      id_table: null,
      data_api: {
        "objectType": "table",
        "id_object": "tbl_1687206780",
        "project": "dev-intercorp-data-storage",
        "dataset": "bi_itcm_somos1",
        "name": "dv_clientes_empresa_ytd",
        "source": "Matillion ETL",
        "input": [{
          "objectType": "table",
          "id_object": "tbl_1687206785",
          "project": "dev-intercorp-data-storage",
          "dataset": "bi_itc_attribute_party",
          "name": "ba_itc_attr_demographic",
          "source": "Matillion ETL"
        }, {
          "objectType": "table",
          "id_object": "tbl_1687206786",
          "project": "dev-intercorp-data-storage",
          "dataset": "master_placement",
          "name": "m_place",
          "source": "Matillion ETL"
        }, {
          "objectType": "table",
          "id_object": "tbl_1687206782",
          "project": "dev-intercorp-data-storage",
          "dataset": "master_transaction",
          "name": "t_retail_transaction",
          "source": "Matillion ETL"
        }],
        "output": []
      }
    };
  },
  methods: {
    transformData: function transformData(data) {
      var output = _objectSpread(_objectSpread({}, data), {}, {
        is_node: true,
        children: []
      });
      var inputChildren = data.input.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          parent: true
        });
      });
      output.children = inputChildren;
      delete output.input;
      delete output.output;
      console.log("log");
      console.log("test: ", output);
      return output;
    },
    getId: function getId(project, dataset, table) {
      var _this = this;
      LineageService.getAllLineage().then(function (response) {
        if (response.success) {
          var tables = response.data.metadata;
          var search = tables.find(function (objeto) {
            return objeto.project === project && objeto.dataset === dataset && objeto.name === table;
          });
          if (search) {
            _this.table_id = search.id_object;
            _this.getTableLineage(_this.table_id);
          } else {
            _this.has_lineage = false;
            console.log("not_found");
          }
          console.log(_this.table_id);
        } else {}
      });
    },
    getTableLineage: function getTableLineage(id) {
      var _this2 = this;
      LineageService.getLineage("table", id).then(function (response) {
        console.log(response);
        if (response.success && response.data.metadata.length > 0) {
          _this2.data_api = response.data.metadata[0];
          console.log(_this2.data_api);
          _this2.render_graph();
        } else {
          console.log("no_data");
          _this2.has_lineage = false;
        }
      });
    },
    render_graph: function render_graph() {
      var herEdgeStyle = {
        stroke: '#000',
        endArrow: false,
        startArrow: false
      };
      var rectConfig = {
        width: 230,
        height: 100,
        lineWidth: 1,
        fontSize: 12,
        radius: 4,
        stroke: '#4298f5',
        opacity: 1
      };
      var nodeOrigin = {
        x: -rectConfig.width / 2,
        y: -rectConfig.height / 2
      };
      var textConfig = {
        textAlign: 'left',
        textBaseline: 'bottom'
      };
      var colorStatus = {
        table: '#6200EA'
      };
      var colorJobType = {
        table: '#6200EA'
      };
      G6.registerNode('flow-rect', {
        draggable: true,
        shapeType: 'flow-rect',
        draw: function draw(cfg, group) {
          var name = cfg.name,
            collapsed = cfg.collapsed,
            id_object = cfg.id_object,
            project = cfg.project,
            dataset = cfg.dataset,
            source = cfg.source,
            objectType = cfg.objectType,
            is_node = cfg.is_node,
            process_name = cfg.process_name,
            source_key = cfg.source_key;
          var rect = group.addShape('rect', {
            attrs: _objectSpread({
              x: nodeOrigin.x,
              y: nodeOrigin.y,
              fill: is_node ? '#cae2fc' : '#fff'
            }, rectConfig)
          });

          // > rectangular box item
          var rectBBox = rect.getBBox();

          // > label title
          var lab_title = "".concat(name);
          group.addShape('text', {
            attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
              x: 12 + nodeOrigin.x,
              y: 20 + nodeOrigin.y,
              text: "".concat(lab_title.length > 28 ? lab_title.substr(0, 28) + '...' : lab_title),
              fontSize: 12,
              fill: '#000',
              opacity: 0.7,
              fontWeight: 'bold'
            }),
            name: 'name-shape'
          });

          // > company_code
          group.addShape('text', {
            attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
              x: 12 + nodeOrigin.x,
              y: rectBBox.maxY - 60,
              text: "Proyecto: ".concat(project.length > 28 ? project.substr(0, 28) + '...' : project),
              fontSize: 10,
              fill: '#000',
              opacity: 0.7
            })
          });

          // > company_code, name
          group.addShape('text', {
            attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
              x: 12 + nodeOrigin.x,
              y: rectBBox.maxY - 50,
              text: "Dataset: ".concat(dataset.length > 28 ? dataset.substr(0, 28) + '...' : dataset),
              fontSize: 10,
              fill: '#000',
              opacity: 0.7
            })
          });
          group.addShape('text', {
            attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
              x: 12 + nodeOrigin.x,
              y: rectBBox.maxY - 40,
              text: is_node ? "" : "Job: ".concat(process_name ? process_name.length > 28 ? process_name.substr(0, 28) + '...' : process_name : 'undefined'),
              fontSize: 10,
              fill: '#000',
              opacity: 0.7
            })
          });
          group.addShape('text', {
            attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
              x: 12 + nodeOrigin.x,
              y: rectBBox.maxY - 12,
              text: is_node ? "" : " ".concat(source),
              fontSize: 10,
              fill: '#000',
              opacity: 0.7
            })
          });
          group.addShape('text', {
            attrs: {
              x: rectBBox.maxX - 5,
              y: 20 + nodeOrigin.y,
              text: "\uF2FD",
              // Sustituye esto con el código MDI de tu icono
              fontSize: 15,
              // Tamaño del icono
              textAlign: 'right',
              cursor: 'pointer',
              fill: '#111',
              // Color del icono
              fontFamily: 'Material Design Icons' // Nombre de la fuente de MDI
            },
            name: 'info-icon'
          });

          // > job_code
          /*const percentText = group.addShape('text', {
            attrs: {
              ...textConfig,
              x: rectBBox.maxX - 12,
              y: rectBBox.maxY - 12,
              text: `${objectType}`,
              fontSize: 11,
              textAlign: 'right',
              fill: '#000',
              opacity: 0.7
            },
          });*/

          group.addShape('image', {
            attrs: {
              img: is_node ? "" : source_key == "matillion" ? require("../../assets/matillion.png") : require("../../assets/bigquery_logo.png"),
              x: -nodeOrigin.x - 50,
              y: rectBBox.maxY - 30,
              width: 40,
              height: 20
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'main-selected-shape'
          });
          group.addShape('image', {
            attrs: {
              img: is_node ? require("../../assets/inca_200x75.png") : "",
              x: -nodeOrigin.x - 48,
              y: rectBBox.maxY - 20,
              width: 40,
              height: 15
            },
            // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
            name: 'main-inca'
          });

          // > circle symbol --> status
          /*const symbol = collapsed ? 'circle' : 'square';
          const circle = group.addShape('marker', {
            attrs: {
              ...textConfig,
              x: percentText.getBBox().minX - 10,
              y: rectBBox.maxY - 12 - 6,
              symbol,
              r: 6,
              fill: colorStatus[objectType],
            },
          });*/

          // > bottom rectangle (background) --> job_type
          var bottomRect = group.addShape('rect', {
            attrs: {
              x: nodeOrigin.x,
              y: rectBBox.maxY - 4,
              width: rectBBox.width - 1,
              height: 5,
              radius: [0, 0, rectConfig.radius, rectConfig.radius],
              fill: cfg.is_node ? "transparent" : "#0021cf"
            }
          });

          // > collapse rect
          /*if (cfg.children && cfg.children.length) {
            group.addShape('rect', {
              attrs: {
                x: rectConfig.width / 2 - 8,
                y: -8,
                width: 16,
                height: 16,
                stroke: 'rgba(0, 0, 0, 0.25)',
                cursor: 'pointer',
                fill: '#fff',
              },
              name: 'collapse-back',
              modelId: cfg.id,
            });
            // >> collapse text
            group.addShape('text', {
              attrs: {
                x: rectConfig.width / 2,
                y: -1,
                textAlign: 'center',
                textBaseline: 'middle',
                text: collapsed ? '+' : '-',
                fontSize: 16,
                cursor: 'pointer',
                fill: 'rgba(0, 0, 0, 0.25)',
              },
              name: 'collapse-text',
              modelId: cfg.id,
            });
          }*/
          this.drawLinkPoints(cfg, group);
          return rect;
        },
        setState: function setState(name, value, item) {
          if (name === 'collapse') {
            var group = item.getContainer();
            var collapseText = group.find(function (e) {
              return e.get('name') === 'collapse-text';
            });
            if (collapseText) {
              if (!value) {
                collapseText.attr({
                  text: '-'
                });
              } else {
                collapseText.attr({
                  text: '+'
                });
              }
            }
          }
        },
        getAnchorPoints: function getAnchorPoints() {
          return [[0, 0.5], [1, 0.5]];
        }
      }, 'rect');
      var dataTransform = function dataTransform(data) {
        var _changeData = function changeData(d) {
          var data = _objectSpread({}, d);
          data.type = 'flow-rect';
          if (!d.direction) {
            if (!d.direction) {
              data.direction = 'left';
            }
          }
          if (d.children) {
            data.children = d.children.map(function (child) {
              return _changeData(child);
            });
          }
          return data;
        };
        return _changeData(data);
      };
      var width = 1104;
      var height = 444;
      var tree = new G6.TreeGraph({
        container: 'container',
        width: width,
        height: height,
        fitView: true,
        plugins: [tooltip],
        fitViewPadding: [10, 20],
        layout: {
          type: 'mindmap',
          direction: 'H',
          getHeight: function getHeight() {
            return 60;
          },
          getWidth: function getWidth() {
            return 60;
          },
          getVGap: function getVGap() {
            return 40;
          },
          getHGap: function getHGap() {
            return 150;
          },
          getSide: function getSide(node) {
            return node.data.direction;
          }
        },
        defaultEdge: {
          type: 'cubic-horizontal',
          style: herEdgeStyle
        },
        minZoom: 0.1,
        maxZoom: 1.7,
        modes: {
          default: ['drag-canvas', 'zoom-canvas', 'dice-mindmap', 'drag-node', 'collapse-expand']
        }
      });
      tree.data(dataTransform(this.data_api));
      tree.render();
    }
  },
  created: function created() {
    console.log(this.table);
    var asd = this.table.item;
    if ("table" in asd) {
      console.log("object");
      this.getId(asd.table.projectId, asd.table.datasetId, asd.table.objectId);
    } else {
      console.log("test");
      this.getId(asd.tableReference.projectId, asd.tableReference.datasetId, asd.tableReference.tableId);
    }
  },
  mounted: function mounted() {
    //this.render_graph()
  }
};